import script from "./RFPsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./RFPsTab.vue?vue&type=script&setup=true&lang=js"

import "./RFPsTab.vue?vue&type=style&index=0&id=a5636aea&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5636aea"]])

export default __exports__